module.exports = __webpack_public_path__ + "media/images/web/svg/growed-logo-eb832b98ae32e9491de33e0546f5bb8f.svg";